import { useTranslation } from 'react-i18next';
import { useMeQuery } from '@platform/state/api';
import { Segmented } from '@platform/ui';
import type { Lang } from '@platform/core/types';
import { initials } from './initials';
import { useLanguage } from './useLanguage';

const ROLE_KEYS: Record<string, string> = { 'Platform admin': 'admin', Customizer: 'customizer', None: 'none' };

/**
 * Вкладка «Обліковий запис» профілю (прототип v4): картка з ініціалами 56px, ім'я та e-mail (з облікового запису входу — лише перегляд),
 * глобальна роль і мова інтерфейсу (українська / English; зберігається в профілі на сервері).
 */
export function ProfileAccount() {
  const { t } = useTranslation();
  const { data: me } = useMeQuery();
  const [lang, setLang] = useLanguage();
  const field = (label: string, value: string) => (
    <label className="pf-field"><span className="pf-field__label">{label}</span><input className="pf-field__input" value={value} disabled readOnly /></label>
  );
  return (
    <div className="pf-card">
      <span className="pf-avatar" aria-hidden="true">{initials(me?.displayName)}</span>
      <div className="pf-fields">
        {field(t('profilePage.fullName'), me?.displayName ?? '')}
        {field(t('profilePage.email'), me?.email ?? '')}
        {field(t('profilePage.globalRole'), t(`profilePage.globalRoles.${ROLE_KEYS[me?.globalRole ?? 'None'] ?? 'none'}`))}
        <div className="pf-field">
          <span className="pf-field__label">{t('profilePage.language')}</span>
          <Segmented<Lang> options={[{ value: 'uk', label: t('profilePage.ukrainian') }, { value: 'en', label: t('profilePage.english') }]} value={lang} onChange={setLang} />
        </div>
      </div>
    </div>
  );
}
